'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPurchasedProducts = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * getProducts
 * 
 * Fetches a list of products.
 * @param {String} feis_id 
 */
var getPurchasedProducts = exports.getPurchasedProducts = function getPurchasedProducts(feis_id) {
  return function (dispatch, getState) {

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/accounts/purchases'
      },
      types: ['GET_PURCHASED_PRODUCTS_START', 'GET_PURCHASED_PRODUCTS', 'GET_PURCHASED_PRODUCTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/getPurchasedProducts.js
// module id = 155
// module chunks = 0